const ENV = process.env.REACT_APP_ENV || 'development';

export function isStaging() {
  return ENV === 'staging';
}

export function isProduction() {
  return ENV === 'production';
}

export function isDevelopment() {
  return ENV === 'development';
}

export function getEnv() {
  return ENV;
}
